import { load } from '@cashfreepayments/cashfree-js';
import { postApi } from '../../services/api';
import { showSnack } from 'react-redux-snackbar';
import { verifyToken } from '../../redux/actions';
let cashfree;
let initializeSDK = async function () {
	cashfree = await load({
		mode: 'production',
	});
};
initializeSDK();
export function Checkout(sessionId) {
	let checkoutOptions = {
		paymentSessionId: sessionId,
		redirectTarget: '_self',
	};
	cashfree.checkout(checkoutOptions);
}

export async function createOrder(planSelected, interval, navigate, dispatch) {
	try {
		const resp = await postApi({ planSelected, interval }, '/assetze/order');
		if (resp.type === 'success') {
			if (resp.code === 'INIT_PG_PAYMENT') {
				Checkout(resp.pgRequest.payment_session_id);
			}
			if (resp.code === 'SUBSCRIPTION_DONE') {
				await dispatch(verifyToken());
				navigate('/dashboard');
			}
		}
		return resp;
	} catch (e) {
		console.error(e);
	}
}

export async function verifyOrder(orderId, navigate, dispatch) {
	try {
		const resp = await postApi({ orderId }, '/assetze/order/verify');

		if (resp.type === 'success') {
			if (resp.code === 'SUBSCRIPTION_DONE') {
				dispatch(showSnack('SUBSCRIPTION_DONE', { label: 'Successfully subscribed', timeout: 7000 }));
				await dispatch(verifyToken());
				navigate('/dashboard');
				return;
			}
		} else {
			return dispatch(showSnack('VERIFY_ORDER_FAILED', { label: resp.error, timeout: 7000 }));
		}
	} catch (e) {
		console.error(e);
	}
}
